<template>
    <div>
      <a-card>

        <div class="flex justify-between mb-5">
          <div class="text-2xl font-semibold">Note</div>
          <div class="flex gap-2">
            <a-button  type="primary"
                       ghost
                       icon="filter"
                       @click="showDrawer"
                       class="mt-5 md:mt-0"
                       style="border-radius: 3px !important;"
            >
              Filters
            </a-button >
            <a-button v-if="hasPermission('note.create')" type="primary" class="text-base notes self-center" @click="discard('/notes/add')" style="border-radius: 3px !important;">Add Note</a-button>
          </div>
        </div>
        <a-card>
          <a-form :form="form">
            <a-tabs class="tabs-note" @change="changeTab" v-model="current_tab">
              <a-tab-pane key="1" tab="Matters">
                <selectSearch mode="multiple" v-if="current_tab === '1'" ref="search" class="w-full md:w-1/3" @selectSearch="selectSearch" url="/matter/query/" :options="optionSearchMatter" field="matter" label="Matter" :is_include_matter="true"/>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Contacts">
                <selectSearch mode="multiple" v-if="current_tab === '2'"  class="w-full md:w-1/3" @selectSearch="selectSearch" :options="optionSearchContact" field="contact" label="Contact"/>
              </a-tab-pane>
            </a-tabs>
          </a-form>
        </a-card>

        <div class="flex flex-col md:flex-row justify-between my-5">
          <a-radio-group v-model="type_note" button-style="solid" class="self-center" style="white-space: nowrap">
            <a-radio-button value="All" @click="filterStatus('all')">
              All
            </a-radio-button>
            <a-radio-button value="Open" @click="filterStatus('>','0')">
              With Time
            </a-radio-button>
            <a-radio-button value="Closed" @click="filterStatus('in','0')">
              Without Time
            </a-radio-button>
          </a-radio-group>
        </div>

        <XTable :model="model"
                ref="note"
                :options="options"
                @refresh="refresh"
                @search="searchNote"
                @clickRow="(record)=>clickRow(`/notes/edit/${record.id}`,'note.get')"
                class="mt-5 note"
        >
          <span slot="author" slot-scope="text,record" v-if="text.record.creator">
            {{ text.record.creator.first_name }} {{ text.record.creator.last_name }}
          </span>
          <span slot="notifications" slot-scope="text,record">
            <template v-for="item in text.record.notifications" v-if="text.record.notifications.length">
              <ATag>{{ item.first_name }} {{ item.last_name }}</ATag>
            </template>
          </span>
          <span v-if="hasPermission('note.get') || hasPermission('note.delete')" slot="action" slot-scope="text,record">
            <a-dropdown>
                    <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
                    <a-menu slot="overlay">
                      <a-menu-item v-if="hasPermission('note.get')" key="1" @click="editNote(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                      <a-menu-item v-if="hasPermission('note.delete')" key="2" @click="openModalNote(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    </a-menu>
            </a-dropdown>
          </span>
          <span slot-scope="text,record" slot="contact" v-if="text.record.contact" style="white-space: nowrap">
            {{ text.record.contact.person ? `${text.record.contact.person.first_name} ${text.record.contact.person.last_name}` : `${ text.record.contact.company.name }`  }}
          </span>
          <span slot="time" slot-scope="text,record" style="white-space: nowrap">
            {{ text.record.date ? setDateFormat(text.record.date) : '' }}
          </span>
          <span slot="record" slot-scope="text,record">
            {{ text.record.recorded_time ? text.record.recorded_time + 'h' : '' }}
          </span>
          <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
            {{ text.record.matter.title }}
          </span>
        </XTable>

        <vs-prompt
          color="danger"
          title="Delete Note"
          @cancel="delete_note = false"
          @close="delete_note = false"
          :active.sync="delete_note"
          buttons-hidden
        >
          <div class="text-left">
            <div class="font-medium">Are you sure to delete this note ?</div>
          </div>
          <div class="flex justify-center space-x-3 mt-5">
            <vs-button color="danger" @click="removeNote">delete</vs-button>
            <vs-button color="danger" type="flat" @click="delete_note = false">Cancel</vs-button>
          </div>
        </vs-prompt>

        <Drawer ref="drawer"
                @filter="filtersNote"
                :form="form"
                :ele="$refs.note"
                :query="[
                { field : 'title', value: form.getFieldValue('title') , condition: form.getFieldValue('condition_subject')},
                { field : 'date',  value: form.getFieldValue('date') ,  condition: form.getFieldValue('condition') }
              ]"
        >
          <template>
            <div class="flex space-x-4">
              <a-form-item label="Condition" has-feedback>
                <a-select
                  style="width: 150px"
                  allowClear
                  @change="(e) => handleRemoveSelect(e,'title')"
                  class="select"
                  v-decorator="['condition_subject',{ initialValue: '=' }]"
                >
                  <a-select-option value="=">
                    Equal
                  </a-select-option>
                  <a-select-option value="like">
                    Like
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="subject" has-feedback>
                <a-input
                  v-decorator="['title']"
                  placeholder="title"
                  autocomplete="none"
                  class="ant-input"
                />
              </a-form-item>
            </div>
            <div class="flex space-x-4">
              <a-form-item label="Condition" has-feedback>
                <a-select
                  style="width: 150px"
                  allowClear
                  class="select"
                  @change="(e) => handleRemoveSelect(e,'date')"
                  v-decorator="['condition',{ initialValue: 'like' }]"
                >
                  <a-select-option value="like">
                    Equal
                  </a-select-option>
                  <a-select-option value=">">
                    Greater
                  </a-select-option>
                  <a-select-option value="<">
                    Less
                  </a-select-option>
                  <a-select-option value="<=">
                    Smaller than equal
                  </a-select-option>
                  <a-select-option value=">=">
                    Larger equals
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Date" has-feedback>
                <a-date-picker
                  v-decorator="['date']"
                  :format="dateFormat"
                  valueFormat="YYYY-MM-DD"
                  class="w-full"
                />
              </a-form-item>
            </div>
            <div
              :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  direction:'rtl',
                  zIndex: 1,
               }"
            >
              <a-button :style="{ borderRadius: '3px' }" type="primary" html-type="submit">
                Save filter
              </a-button>
            </div>
          </template>
        </Drawer>

      </a-card>
    </div>
</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableCol from './tblNote'
import axios from "@/axios"
import Mixin from '../mixin/mixin'
import selectSearch from "@/views/forms/selectSearch";
import Drawer from '../drawer/Drawer'


export default {
  name: "Listnote",
  mixins:[Mixin],
  props:{
    hasFilterContact:{
      type: Boolean,
      default: false
    },
    hasFilterMatter:{
      type: Boolean,
      default: false
    },
  },
  components:{
    XTable,
    selectSearch,
    Drawer
  },
  data(){
    return{
      model: null,
      current_tab:"1",
      delete_note:false,
      type_note: 'All',
      options:{
        placeholder:'Search notes',
        noContent: 'No notes',
        is_row_selection: false,
        is_load_req: false,
        temp_row: null
      }
    }
  },
  methods:{

    dropDownClick(e){
      console.log('aaaa')
      e.preventDefault()
    },

    filtersNote(){
      this.type_note = 'none'
    },

    showDrawer(){
      this.$refs.drawer.visible_drawer = true
    },

    searchNote(search){
      search === null || search === '' ? this.type_note = 'All' : this.type_note = 'none'
    },

    refresh(){
      this.clearForm()
      this.type_note = 'All'
    },

    clearForm(){
      this.form.setFieldsValue({ matter: undefined })
      this.form.setFieldsValue({ contact: undefined })
    },

    async filterStatus(condition,value){
      this.clearForm()
      this.checkPagenation(this.$refs.note)
      condition === 'all' ?
      this.$refs.note.query.query = undefined :
      this.$refs.note.query.query = [{ field:'recorded_time',condition:condition,value: value }]
      await this.$refs.note.fetch()
    },

    changeTab(){
      if(this.form.getFieldValue('matter') || this.form.getFieldValue('contact')){
        this.$refs.note.query.query = undefined
        this.$refs.note.data = []
        this.$refs.note.fetch()
      }
    },

    async selectSearch(id,has_matter){
      if(id.length === 0){
        this.type_note = 'All'
        this.$refs.note.query.query = undefined
      }else{
        this.type_note = 'none'
        has_matter ?
        this.$refs.note.query.query  = [{ field: 'matter__id',condition: 'in', value: id }] :
        this.$refs.note.query.query = [{ field: 'contact__id',condition: 'in', value: id }]
      }
      await this.$refs.note.fetch()
    },

    openModalNote(id){
      this.delete_note = true
      this.temp_row = id
    },

    async removeNote(){
      try{
        const id = this.temp_row
        this.delete_note = false
        this.$refs.note.loading = true
        await axios.delete(`/note/${id}/`)
        await this.$refs.note.fetch()
        this.$notification['success']({
          message: 'Success',
          description:`Note deleted.`,
        });
      }catch (e){
        this.$notification['error']({
          message: 'Server Error',
          description:`Please try again.`,
        });
      }finally {
        this.$refs.note.loading = false
      }
    },

    editNote(id){
      this.$router.push(`/notes/edit/${id}`)
    }
  },
  async mounted() {
    this.is_click_add_time = true
    if (this.hasFilterContact)
      this.$refs.note.query.query = [{ field: 'contact__id',condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id  }]
    if (this.hasFilterMatter)
      this.$refs.note.query.query = [{ field: 'matter__id',condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id  }]
    await this.$refs.note.fetch()
  },
  created() {
    this.model = TableCol.default
  }
}
</script>

<style>
    @import "../style/style.css";
    .notes{
      text-align: right;
      display: block;
      margin-left: auto;
    }
    [dir] .ant-card-bordered{
      border-radius: 6px;
    }
    [dir=ltr] .ant-radio-button-wrapper:first-child{
      border-radius: 3px 0 0 3px;
    }
    [dir=ltr] .ant-radio-button-wrapper:last-child{
      border-radius: 0 3px 3px 0;
    }
    .anticon.anticon-check-circle{
      /*color: #3a3dbe!important;*/
    }
    .ant-table-column-has-actions span{
      white-space: nowrap;
    }
    @media (max-width: 600px) {
      .tabs-note .ant-tabs-bar.ant-tabs-top-bar{
        display: flex;
        flex-direction: column;
      }
      .ant-tabs-bar.ant-tabs-top-bar .ant-tabs-extra-content{
        padding-bottom: 1.5rem;
      }
      .ant-tabs-extra-content button{
        width: 100%;
        text-align: center;
      }
      .ant-tabs-nav-container{
        text-align: center;
      }
    }
    @media (max-width: 400px) {
       .ant-radio-group.ant-radio-group-solid{
         display: flex;
         flex-direction: column;
         text-align: center;
       }
      .ant-radio-group.ant-radio-group-solid label{
        margin-bottom: 0.5em;
        border-radius: 3px !important;
      }
    }
/*  css general  */

    #layout.blog-page{
      background: #696969;
    }
    #header-container #header .header-wrap>.row:last-child .header-main-panel .header-col-fluid .fixed-header-logo{
      visibility: hidden !important
    }
    #header-container.small .mobile-logo img{
     position: relative;
     top: 10px;
    }

</style>
